export default __webpack_public_path__ + "static/media/030-mixer.36ba151e.svg";